import { render, staticRenderFns } from "./NavMenuItem.vue?vue&type=template&id=424f74ca"
import script from "./NavMenuItem.vue?vue&type=script&lang=js"
export * from "./NavMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('424f74ca')) {
      api.createRecord('424f74ca', component.options)
    } else {
      api.reload('424f74ca', component.options)
    }
    module.hot.accept("./NavMenuItem.vue?vue&type=template&id=424f74ca", function () {
      api.rerender('424f74ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/navigation/NavMenuItem.vue"
export default component.exports